import { baseUrls } from "./base-urls";
import { environment } from "./../enum/environment-enum";

let BASE_URL_USER_SERVICE;
let BASE_URL_DOCBUILDER_SERVICE;
let BASE_URL_DOCPARSER_SERVICE;
let BASE_URL_EVENT_SERVICE;
let BASE_URL_AUTH_SERVICE;
let BASE_URL_META_CONTENT_SERVICE;
let VISITOR_SERVICE_URL;
let BASE_URL_PAYMENT_SERVICE;
let BASE_URL_ORDER_SERVICE;
let BASE_URL_ORCHESTRATION_SERVICE;
let BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI;
let BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI;
let BASE_URL_SSO_DASHBOARD;
let BASE_URL_SIGNSIMPI;
let BASE_URL_PDFSIMPI;
let BASE_URL_RESUMEBUILD;
let BASE_DASHBOARD_ORCHESTRATION;
let BASE_URL_TRUSTPILOT;
let BASE_URL_ABTEST;
let BASE_URL_DOC_EDITOR_SERVICE;
let BASE_URL_JOBMANAGER_SERVICE;
let BASE_URL_DOCPROFILE_API;
let BASE_URL_DOCOPERATION_SERVICE;

const currentEnv = import.meta.env.VITE_ENVIRONMENT;
//const currentEnv = `${import.meta.env.REACT_APP_ENVIRONMENT}`;

const baseUrl = {
  userService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.USER_SERVICE,
    QA: baseUrls.QA.USER_SERVICE,
    STAGING: baseUrls.STAGING.USER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.USER_SERVICE,
  },
  docBuilderService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOCBUILDER_SERVICE,
    QA: baseUrls.QA.DOCBUILDER_SERVICE,
    STAGING: baseUrls.STAGING.DOCBUILDER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOCBUILDER_SERVICE,
  },
  docParserService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOCPARSER_SERVICE,
    QA: baseUrls.QA.DOCPARSER_SERVICE,
    STAGING: baseUrls.STAGING.DOCPARSER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOCPARSER_SERVICE,
  },
  eventService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.EVENT_SERVICE,
    QA: baseUrls.QA.EVENT_SERVICE,
    STAGING: baseUrls.STAGING.EVENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.EVENT_SERVICE,
  },
  authService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.AUTH_SERVICE,
    QA: baseUrls.QA.AUTH_SERVICE,
    STAGING: baseUrls.STAGING.AUTH_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.AUTH_SERVICE,
  },
  metaContentService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.META_CONTENT_SERVICE,
    QA: baseUrls.QA.META_CONTENT_SERVICE,
    STAGING: baseUrls.STAGING.META_CONTENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.META_CONTENT_SERVICE,
  },
  paymentService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.PAYMENT_SERVICE,
    QA: baseUrls.QA.PAYMENT_SERVICE,
    STAGING: baseUrls.STAGING.PAYMENT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.PAYMENT_SERVICE,
  },
  orderService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.ORDER_SERVICE,
    QA: baseUrls.QA.ORDER_SERVICE,
    STAGING: baseUrls.STAGING.ORDER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.ORDER_SERVICE,
  },
  orchestrationService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.ORCHESTRATION_SERVICE,
    QA: baseUrls.QA.ORCHESTRATION_SERVICE,
    STAGING: baseUrls.STAGING.ORCHESTRATION_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.ORCHESTRATION_SERVICE,
  },
  ssoPdfSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_PDFSIMPLI,
    QA: baseUrls.QA.SINGLE_SIGN_ON_PDFSIMPLI,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_PDFSIMPLI,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_PDFSIMPLI,
  },
  ssoSignSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_SIGNSIMPLI,
    QA: baseUrls.QA.SINGLE_SIGN_ON_SIGNSIMPLI,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_SIGNSIMPLI,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_SIGNSIMPLI,
  },
  ssoDashboard: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SINGLE_SIGN_ON_DASHBOARD,
    QA: baseUrls.QA.SINGLE_SIGN_ON_DASHBOARD,
    STAGING: baseUrls.STAGING.SINGLE_SIGN_ON_DASHBOARD,
    PRODUCTION: baseUrls.PRODUCTION.SINGLE_SIGN_ON_DASHBOARD,
  },
  pdfSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.PDFSIMPLI_URL,
    QA: baseUrls.QA.PDFSIMPLI_URL,
    STAGING: baseUrls.STAGING.PDFSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.PDFSIMPLI_URL,
  },
  signSimpli: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.SIGNSIMPLI_URL,
    QA: baseUrls.QA.SIGNSIMPLI_URL,
    STAGING: baseUrls.STAGING.SIGNSIMPLI_URL,
    PRODUCTION: baseUrls.PRODUCTION.SIGNSIMPLI_URL,
  },
  resumeBuild: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.RESUMEBUILD_URL,
    QA: baseUrls.QA.RESUMEBUILD_URL,
    STAGING: baseUrls.STAGING.RESUMEBUILD_URL,
    PRODUCTION: baseUrls.PRODUCTION.RESUMEBUILD_URL,
  },
  dashboardOrchestrationService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DASHBOARD_ORCH_SERVICE,
    QA: baseUrls.QA.DASHBOARD_ORCH_SERVICE,
    STAGING: baseUrls.STAGING.DASHBOARD_ORCH_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DASHBOARD_ORCH_SERVICE,
  },
  TrustPilotService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.TRUSTPILOT_SERVICE,
    QA: baseUrls.QA.TRUSTPILOT_SERVICE,
    STAGING: baseUrls.STAGING.TRUSTPILOT_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.TRUSTPILOT_SERVICE,
  },
  abtestService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.ABTEST_SERVICE,
    QA: baseUrls.QA.ABTEST_SERVICE,
    STAGING: baseUrls.STAGING.ABTEST_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.ABTEST_SERVICE,
  },
  DocEditorService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOC_EDITOR_SERVICE,
    QA: baseUrls.QA.DOC_EDITOR_SERVICE,
    STAGING: baseUrls.STAGING.DOC_EDITOR_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOC_EDITOR_SERVICE,
  },
  jobManagerService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.JOBMANGER_SERVICE,
    QA: baseUrls.QA.JOBMANGER_SERVICE,
    STAGING: baseUrls.STAGING.JOBMANGER_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.JOBMANGER_SERVICE,
  },
  docProfileService: {
    DEVELOPMENT: baseUrls.DEVELOPMENT.DOC_PROFILE_SERVICE,
    QA: baseUrls.QA.DOC_PROFILE_SERVICE,
    STAGING: baseUrls.STAGING.DOC_PROFILE_SERVICE,
    PRODUCTION: baseUrls.PRODUCTION.DOC_PROFILE_SERVICE,
  },
  docOperationService: {
  DEVELOPMENT: baseUrls.DEVELOPMENT.DOCOPERATION_SERVICE,
  QA: baseUrls.QA.DOCOPERATION_SERVICE,
  STAGING: baseUrls.STAGING.DOCOPERATION_SERVICE,
  PRODUCTION: baseUrls.PRODUCTION.DOCOPERATION_SERVICE,
  },
};
switch (currentEnv) {
  case environment.DEVELOPMENT:
     //console.log("api const dev current-react-environment::", `${import.meta.env.REACT_APP_ENVIRONMENT}`);
     //console.log("api const dev current-vite-environment::", `${import.meta.env.VITE_ENVIRONMENT}`);
    
    BASE_URL_USER_SERVICE = baseUrl.userService.DEVELOPMENT;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.DEVELOPMENT;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.DEVELOPMENT;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.DEVELOPMENT;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.DEVELOPMENT;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.DEVELOPMENT;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.DEVELOPMENT;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.DEVELOPMENT;
    VISITOR_SERVICE_URL = "https://static-qa.worksimpli.io/cdn/content/js/visitor.js";
    BASE_URL_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.DEVELOPMENT;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.DEVELOPMENT;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.DEVELOPMENT;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.DEVELOPMENT;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.DEVELOPMENT;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.DEVELOPMENT;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.DEVELOPMENT;
    BASE_URL_ABTEST = baseUrl.abtestService.DEVELOPMENT;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.DEVELOPMENT;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.DEVELOPMENT;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.DEVELOPMENT;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.DEVELOPMENT;
    break;
  case environment.QA:
     console.log(" api const qa current-react-environment::", `${import.meta.env.REACT_APP_ENVIRONMENT}`);
    // console.log("api const qa current-vite-environment::", `${import.meta.env.VITE_ENVIRONMENT}`);
    
    BASE_URL_USER_SERVICE = baseUrl.userService.QA;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.QA;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.QA;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.QA;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.QA;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.QA;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.QA;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.QA;
    VISITOR_SERVICE_URL = "https://static-qa.worksimpli.io/cdn/content/js/visitor.js";
    BASE_URL_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.QA;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.QA;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.QA;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.QA;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.QA;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.QA;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.QA;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.QA;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.QA;
    BASE_URL_ABTEST = baseUrl.abtestService.QA;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.QA;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.QA;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.QA;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.QA;
    break;
  case environment.STAGING:
    
     console.log(" api const stagin current-react-environment::", `${import.meta.env.REACT_APP_ENVIRONMENT}`);
    // console.log("api const staging current-vite-environment::", `${import.meta.env.VITE_ENVIRONMENT}`);
    BASE_URL_USER_SERVICE = baseUrl.userService.STAGING;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.STAGING;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.STAGING;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.STAGING;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.STAGING;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.STAGING;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.STAGING;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.STAGING;
    VISITOR_SERVICE_URL = "https://static.worksimpli.io/cdn/content/js/visitor.js";
    BASE_URL_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.STAGING;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.STAGING;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.STAGING;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.STAGING;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.STAGING;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.STAGING;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.STAGING;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.STAGING;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.STAGING;
    BASE_URL_ABTEST = baseUrl.abtestService.STAGING;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.STAGING;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.STAGING;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.STAGING;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.STAGING;
    break;
  case environment.PRODUCTION:
    
     console.log(" api const prod current-react-environment::", `${import.meta.env.REACT_APP_ENVIRONMENT}`);
    // console.log("app prod current-vite-environment::", `${import.meta.env.VITE_ENVIRONMENT}`);
    BASE_URL_USER_SERVICE = baseUrl.userService.PRODUCTION;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.PRODUCTION;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.PRODUCTION;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.PRODUCTION;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.PRODUCTION;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.PRODUCTION;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.PRODUCTION;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.PRODUCTION;
    VISITOR_SERVICE_URL = "https://static.worksimpli.io/cdn/content/js/visitor.js";
    BASE_URL_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.PRODUCTION;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.PRODUCTION;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.PRODUCTION;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.PRODUCTION;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.PRODUCTION;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.PRODUCTION;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.PRODUCTION;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.PRODUCTION;
    BASE_URL_TRUSTPILOT = baseUrl.TrustPilotService.PRODUCTION;
    BASE_URL_ABTEST = baseUrl.abtestService.PRODUCTION;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.PRODUCTION;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.PRODUCTION;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.PRODUCTION;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.PRODUCTION;
    break;
  //   case environmentTest.DEVELOPMENT:
  //     BASE_URL_USER_SERVICE = baseUrl.userService.DEVELOPMENT;
  //     BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.DEVELOPMENT;
  //     BASE_URL_EVENT_SERVICE = baseUrl.eventService.DEVELOPMENT;
  //   break;
  default:
    BASE_URL_USER_SERVICE = baseUrl.userService.QA;
    BASE_URL_DOCBUILDER_SERVICE = baseUrl.docBuilderService.QA;
    BASE_URL_DOCPARSER_SERVICE = baseUrl.docParserService.QA;
    BASE_URL_EVENT_SERVICE = baseUrl.eventService.QA;
    BASE_URL_AUTH_SERVICE = baseUrl.authService.QA;
    BASE_URL_META_CONTENT_SERVICE = baseUrl.metaContentService.QA;
    BASE_URL_PAYMENT_SERVICE = baseUrl.paymentService.QA;
    BASE_URL_ORDER_SERVICE = baseUrl.orderService.QA;
    VISITOR_SERVICE_URL = "https://static.worksimpli.io/cdn/content/js/visitor.js";
    BASE_URL_ORCHESTRATION_SERVICE = baseUrl.orchestrationService.DEVELOPMENT;
    BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI = baseUrl.ssoPdfSimpli.QA;
    BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI = baseUrl.ssoSignSimpli.QA;
    BASE_URL_SSO_DASHBOARD = baseUrl.ssoDashboard.QA;
    BASE_URL_SIGNSIMPI = baseUrl.signSimpli.QA;
    BASE_URL_PDFSIMPI = baseUrl.pdfSimpli.QA;
    BASE_URL_RESUMEBUILD = baseUrl.resumeBuild.QA;
    BASE_URL_ABTEST = baseUrl.abtestService.QA;
    BASE_URL_DOC_EDITOR_SERVICE = baseUrl.DocEditorService.QA;
    BASE_URL_JOBMANAGER_SERVICE = baseUrl.jobManagerService.QA;
    BASE_URL_DOCOPERATION_SERVICE = baseUrl.docOperationService.QA;
    BASE_DASHBOARD_ORCHESTRATION = baseUrl.dashboardOrchestrationService.QA;
    BASE_URL_DOCPROFILE_API = baseUrl.docProfileService.QA;
    break;
}

export const endPoints = {
  userService: {
    API_V1: "/api/v1",
    API_V2: "/api/v2",
    CREATE_USER: "user",
    CREATE_EXTERNAL_USER: "user/social",
    UPDATE_PWD: "user/change-password",
    RESET_PWD: "user/reset-password",
    GET_USER_PROFILE: "userprofile/:userGuid",
    SIGNIN_AS_ADMIN: "user/admin",
    GET_USER_BY_EMAIL: "user/search?email=:email",
    GET_USER_BY_USERNAME: "user/search?username=:username",
    FORGOT_PWD: "user/forgot-password",
    GET_USER_BY_GUID: "user/search?userguid=:guid",
    GET_USER_OBJECT: "user/abridged",
    LOGIN_ATTEMPT: "user/login-attempt",
    RECAPTCHA_SCORE: "user/captcha-score?greToken=:greToken&portal=:portal",
    VALIDATE_LGCT_EXPIRY: "user/validate-lgct-token?token=:token",
    SAVE_USER_ADDRESS: "user/address",
    IP_2_CONNECT: "user/ip2connect?ipaddress=:ipaddress",
    GET_USER_PROFILE_ABRIDGED: "userprofile/:userGuid/abridged",
  },
  docBuilderService: {
    API_V1: "/api/v1",
    CREATE_DOCUMENT: "doc",
    GET_DOCUMENT: "doc/:docId",
    DUPLICATE_DOCUMENT: "doc/:docId/duplicate",
    DELETE_DOCUMENT: "doc/:docId",
    MAP_DOCUMENT: "doc/:docId/user",
    UPDATE_DOC_STYLE: "doc/:docId/docstyle",
    DELETE_DOC_STYLE: "doc/:docId/paragraph/:paraId",
    UPDATE_PARAGRAPH_ORDERING: "doc/:docId/para-reorder",
    CHOOSE_TEMPLATE: "doc/:docId/choose-template",
    UPDATE_PARAGRAPH: "doc/:docId/paragraph/:paraId",
    RENAME_PARAGRAPH: "doc/:docId/paragraph/:paraId/rename",
    // DOCUMENT_DOWNLOAD:
    //   "doc/:docId/download?downloadDocType=:downloadDocType&docConversionMethod=:docConversionMethod",
    DOCUMENT_DOWNLOAD:
      "doc/:docId/download?downloadDocType=:downloadDocType&docConversionMethod=:docConversionMethod&version=:version&userId=:userId&regenerateDoc=:regenerateDoc",
    //CONVERSION_STATUS: "doc/:conversionId/download-status",
    CONVERSION_STATUS: "doc/:docId/download-statusv2/:conversionId",
    RENAME_DOCUMENT: "doc/:docId/doc-rename",
    GENERATE_PDF_PATH: "doc/:docId/genereate-pdf-path?userId=:userId",
    DOC_PARSE: "doc",
    UPLOAD_IMAGE: "doc/:docId/image",
    GET_ALLDOCUMENT_OF_USER: "doc/user/:userGuid",
  },
  eventService: {
    API_V1: "/api/v1",
    CREATE_EVENT: "/api/v1/event",
  },
  authService: {
    API_V1: "/api/v1",
    USER_AUTH: "v1/auth/user/generate-token-userguid",
    LOGIN_USER_AUTH: "v1/auth/user/generate-token",
    UNAUTH_USER: "v1/auth/service/generate-token",
  },
  metaContentService: {
    API_V1: "/api/v1",
    GET_INDUSTRY: "docmetacontent/industry",
    WRITING_CONTENT: "docmetacontent/MetaContent",
    WRITING_CONTENT_BY_INDUSTRY: "docmetacontent/MetaContentByIndustry",
  },
  paymentService: {
    API_V1: "/api/v1",
    GET_PLANS: "payment-process/plans",
    PAYMENT_PROCESS: "payment-process",
    GET_SKU_DETAILS: "payment-process/sku",
    BAD_BINS: "payment-process/badbin",
    PAYMENT_INTENT: "payment-process/payment-intent",
    GET_GUSETUSER_PRICING:
      "payment-process/calculate/pricing?skuguid=:skuguid&currency=:currency&skucategory=:skucategory&users=:users",
    TAX_MATRIX:
      "payment-process/taxmatrix?statecode=:stateCode&zipcode=:zipCode&amount=:planAmount",
  },
  orderService: {
    API_V1: "/api/v1",
    GET_USER_ORDERS: "Order/GetUserOrders",
  },
  orchestrationService: {
    API_V1: "/api/v1",
    CHECKOUT: "checkout",
    BILLING_INFO: ":userGuid/billing/:localeVal",
    CANCEL_USER: "user/:userGuid/cancel",
    RESTART_SUB: "reactivate/user/:userGuid/order",
    SET_CONFIRMATION: "user/:userGuid/confirmation",
    GET_USER_PLANS: "plans/:userGuid",
    CHECKOUT_3DS: "checkout/3ds",
    GATEWAY_ABTEST: "gateway?cardtoken=:cardtoken&currency=:currency&portal=:portal",
  },
  ssoLogin: {
    partnerLogin: "partner-login?legacyTicket=:legacyTicketCookie",
    partnerLogOut: "partner-logout",
  },
  dashboardOrchestrationService: {
    BILLING_INFO: "/api/v1/dashboard/billing/account/:userGuid/:locale",
    UPLOAD_DOCUMENT: "/api/v1/dashboard/upload-documents",
    SAS_TOKEN: "/api/v2/dashboard/generate-sas-token?expiryHours=:expiryHours",
    OPERATION_LIMIT:"/api/v1/dashboard/operation-Limit",
    UPDATE_DOCUMENT_ACTION: "/api/v1/dashboard/doc",
    CONVERT_DOC: "/api/v2/dashboard/convert-doc",
  },
  abtestService: {
    USER_CONDUCT: "/user/conduct",
    VISITOR_CONDUCT: "/visitor/conduct",
  },
  docEditorService: {
    EDITOR_INFO: "api/v1/operation/editor-info?id=:id",
    PROCESS_ANNOTATION: "api/v1/annotations/process-annotation",
    REPLACE_SIGNATURE: "api/v1/operation/replace-signature",
    ADD_WIZARD: "api/v1/wizard",
    TRACK_EVENT: "api/v2/track/event",
    SAVE_EDITOR_INFO: "api/v1/operation/editor-info",
    IMAGE_GENERATION: "api/v1/imagegeneration",
    MUSIC_GENERATION: "api/v1/music/generation",
    MUSIC_STEM_SEPARATION: "api/v1/music/stem-separation",
  },
  jobManagerService: {
    JOB_STATUS: "jobstatus/:operationId",
    POST_JOB:"jobstatus"
  },
  docOperationService: {
  DOC_OPERATION: "doc-operation",
  },
  docProfileService: {
    BLOB_DOWNLOAD:
      "api/v1/docprofile/generate-uri-download?blobContainer=:blobContainer&fileName=:fileName&newFileName=:newFileName",
    CREATE_DOCPROFILE: "api/v1/docprofile?userid=:userid&isnewsetup=:isnewsetup",
    GET_COMPLETE_DOCPROFILE: "api/v1/docprofile?userid=:userid",
    GET_DOCPROFILE: "api/v1/docprofile/:userid/doc/:docid",
    UPDATE_DOCPROFILE: "api/v1/docprofile/user/:userid/doc",
    MULTIPLE_DOCPROFILE: "api/v1/docprofile/process?userid=:userid&isnewsetup=:isnewsetup",
  },
};
const getBaseUrl = (baseUrl: any) => {
  return (endPoint: any) => {
    return `${baseUrl}${endPoint}`;
  };
};
const getBaseUrlV2 = (baseUrl: any) => {
  return `${baseUrl}`;
};

export const getUserServiceEndPoint = getBaseUrl(BASE_URL_USER_SERVICE);
export const getDocBuilderServicendPoint = getBaseUrl(BASE_URL_DOCBUILDER_SERVICE);
export const getDocParserServicendPoint = getBaseUrl(BASE_URL_DOCPARSER_SERVICE);

export const getEventServiceEndPoint = getBaseUrl(BASE_URL_EVENT_SERVICE);
export const getAuthServiceEndPoint = getBaseUrl(BASE_URL_AUTH_SERVICE);
export const getMetaContentServiceEndPoint = getBaseUrl(BASE_URL_META_CONTENT_SERVICE);

export const getVisitorServiceUrl = getBaseUrl(VISITOR_SERVICE_URL);
export const getPaymentServiceEndPoint = getBaseUrl(BASE_URL_PAYMENT_SERVICE);
export const ERROR_CODES = {
  UNAUTHORISED: 401,
};
export const getOrderServiceEndPoint = getBaseUrl(BASE_URL_ORDER_SERVICE);
export const getOrchestrationServiceEndPoint = getBaseUrl(BASE_URL_ORCHESTRATION_SERVICE);
export const getSsoPdfsimpliEndPoint = getBaseUrl(BASE_URL_SSO_PARTNER_LOGIN_PDFSIMPLI);
export const getSsoSignsimpliEndPoint = getBaseUrl(BASE_URL_SSO_PARTNER_LOGIN_SIGNSIMPLI);
export const getSsoResumeBuildEndPoint = getBaseUrlV2(BASE_URL_SSO_DASHBOARD);
export const getSsoLegalSimpliEndPoint = getBaseUrlV2(BASE_URL_SSO_DASHBOARD);

export const getDashboardOrchestrationServiceEndPoint = getBaseUrl(BASE_DASHBOARD_ORCHESTRATION);

export const getSignSimpliBaseURL = getBaseUrlV2(BASE_URL_SIGNSIMPI);
export const getPdfSimpliBaseURL = getBaseUrlV2(BASE_URL_PDFSIMPI);
export const getResumeBuildBaseURL = getBaseUrlV2(BASE_URL_RESUMEBUILD);

export const getTrustPilotServiceEndPoint = getBaseUrlV2(BASE_URL_TRUSTPILOT);
export const getABTestEndPoint = getBaseUrl(BASE_URL_ABTEST);
export const getDocEditorServiceEndPoint = getBaseUrl(BASE_URL_DOC_EDITOR_SERVICE);
export const getJobManagerServiceEndPoint = getBaseUrl(BASE_URL_JOBMANAGER_SERVICE);
export const getDocOperationServiceEndPoint = getBaseUrl(BASE_URL_DOCOPERATION_SERVICE);
export const getDocProfileEndPoint = getBaseUrl(BASE_URL_DOCPROFILE_API);
